module.exports = __webpack_public_path__ + "img/l_cj.7e861a0e.png";